import { useTrackElement } from '@edreamsodigeo/frontend-core';

const useDatameshTracking = () => {
  const useDatameshTrackLoad = () => {
    const datameshEvent = 'hotels-in-flights_onload';
    return useTrackElement(['display'], datameshEvent);
  };

  const useDatameshTrackClick = () => {
    const datameshEvent = 'hotels-in-flights_click';
    return useTrackElement(['click'], datameshEvent);
  };

  return {
    useDatameshTrackLoad,
    useDatameshTrackClick,
  };
};

export default useDatameshTracking;
